import { dateToCustomPrecisionISO } from './date-to-custom-precision-iso'

/**
 * Get interval string to be used as range parameter for rest apis.
 *
 * @deprecated Please use {@link intervalToString} or {@link exclusiveUpperBoundUtcIntervalString}
 * to create an interval string for REST API calls.
 *
 * @function
 * @param {Date} startDate - The start date instance
 * @param {Date} endDate - The end date instance
 * @return {string} ISO time interval like "2016-08-01T09:30/2016-08-03T14:30"
 */
export function intervalToCustomPrecisionISO(startDate, endDate) {
    return dateToCustomPrecisionISO(startDate, false) + '/' + dateToCustomPrecisionISO(endDate, false)
}
